import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import useEmblaCarousel from 'embla-carousel-react';
import { useState, useCallback, useEffect } from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FullSizedProduct from './FullSizedProduct';
export default function ProductGallery({ product }) {

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, slidesToScroll: 1 });
    const scrollTo = useCallback((index) => {
        if (emblaApi) emblaApi.scrollTo(index);
        setSelectedIndex(index);
    }, [emblaApi]);

    const scrollPrev = () => {
        const prevIndex = selectedIndex === 0 ? product.length - 1 : selectedIndex - 1;
        scrollTo(prevIndex);
    };

    const scrollNext = () => {
        const nextIndex = selectedIndex === product.length - 1 ? 0 : selectedIndex + 1;
        scrollTo(nextIndex);
    };
    useEffect(() => {
        if (!emblaApi) return;
        emblaApi.on('select', () => {
            setSelectedIndex(emblaApi.selectedScrollSnap());
        });
    }, [emblaApi]);

    return (
        <Box sx={{ position: 'relative', width: '100%', mx: 'auto', overflow: 'visible' }}>
            {/* Arrows */}
            <IconButton onClick={scrollPrev} sx={{ position: 'absolute', top: '50%', left: '0', zIndex: 2 }}>
                <ArrowBackIosNewIcon htmlColor='#606d6f' fontSize='large' />
            </IconButton>

            <IconButton onClick={scrollNext} sx={{ position: 'absolute', top: '50%', right: '0', zIndex: 2 }}>
                <ArrowForwardIosIcon htmlColor='#606d6f' fontSize='large' />
            </IconButton>
            {/* Embla Carousel */}
            <Box ref={emblaRef} sx={{ overflow: 'hidden' }}>
                <Box sx={{ display: 'flex' }}>
                    {product.map((item, index) => (
                        <Box sx={{ flex: '0 0 100%' }} key={index}>
                            <FullSizedProduct product={item} />
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}